/* eslint-disable no-param-reassign */
/* eslint-disable no-restricted-syntax */
/* eslint-disable sonarjs/cognitive-complexity */
/* eslint-disable no-plusplus */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-await-in-loop */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { EventParser } from "@coral-xyz/anchor";
import { BN } from "@marinade.finance/marinade-ts-sdk";
import { captureException } from "@sentry/nextjs";
import type { Connection } from "@solana/web3.js";
import { ComputeBudgetProgram, Transaction, PublicKey } from "@solana/web3.js";

import type {
  DepositWithMintAccount,
  LockupType,
} from "../../services/governance/accounts";
import {
  emptyPk,
  getRegistrarPDA,
  getVoterPDA,
} from "../../services/governance/accounts";
import { tryGetRegistrar, tryGetVoter } from "../../services/governance/api";
import type { VsrClient } from "../../services/governance/vsrClient";
import type { MintAccount, TokenProgramAccount } from "../tokens";
import { parseMintAccountData } from "../tokens";

export const MONTHLY = "monthly";
export const DAYS_PER_YEAR = 365;
export const DAYS_PER_MONTH = DAYS_PER_YEAR / 12;

const VOTER_INFO_EVENT_NAME = "VoterInfo";
const DEPOSIT_EVENT_NAME = "DepositEntryInfo";
const SIMULATION_WALLET = "ENmcpFCpxN1CqyUjuog9yyUVfdXBKF3LVCwLr7grJZpk";
const simulationWallet = new PublicKey(SIMULATION_WALLET);

/** @deprecated, probably */
export async function tryGetMint(
  connection: Connection,
  publicKey: PublicKey
): Promise<TokenProgramAccount<MintAccount> | undefined> {
  try {
    const result = await connection.getAccountInfo(publicKey);
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const data = Buffer.from(result!.data);
    const account = parseMintAccountData(data);
    return {
      publicKey,
      account,
    };
  } catch (ex) {
    captureException(ex);
    return undefined;
  }
}

export const getPeriod = (
  lockUpPeriodInDays: number,
  lockupKind: LockupType
) => {
  // in case we do monthly close up we pass months not days.
  //   const maxMonthsNumber = 72
  //   const daysLimit = 2190
  // additional prevention of lockup being to high in case of monthly lockup 72 months as 6 years
  // in case of other types 2190 days as 6 years
  //   if (lockupKind === MONTHLY && period > maxMonthsNumber) {
  //     throw 'lockup period is to hight'
  //   }
  //   if (lockupKind !== MONTHLY && period > daysLimit) {
  //     throw 'lockup period is to hight'
  //   }
  return lockupKind !== MONTHLY
    ? lockUpPeriodInDays
    : lockUpPeriodInDays / DAYS_PER_MONTH;
};

const getDepositsAdditionalInfoEvents = async (
  client: VsrClient,
  usedDeposits: DepositWithMintAccount[],
  connection: Connection,
  registrar: PublicKey,
  voter: PublicKey
) => {
  // because we switch wallet in here we can't use rpc from npm module
  // anchor dont allow to switch wallets inside existing client
  // parse events response as anchor do
  const latestBlockhash = await connection.getLatestBlockhash();
  const events: any[] = [];
  const parser = new EventParser(
    client.program.programId,
    client.program.coder
  );
  const maxRange = 8;
  const maxIndex = Math.max(...usedDeposits.map((x) => x.index)) + 1;
  const numberOfSimulations = Math.ceil(maxIndex / maxRange);
  for (let i = 0; i < numberOfSimulations; i++) {
    const take = maxRange;
    const transaction = new Transaction({ feePayer: simulationWallet });
    transaction.lastValidBlockHeight = latestBlockhash.lastValidBlockHeight;
    transaction.recentBlockhash = latestBlockhash.blockhash;
    const logVoterInfoIx = await client.program.methods
      .logVoterInfo(maxRange * i, take)
      .accounts({ registrar, voter })
      .instruction();
    transaction.add(
      ComputeBudgetProgram.setComputeUnitLimit({ units: 1_000_000 })
    );
    transaction.add(logVoterInfoIx);
    // TODO cache using fetchVotingPowerSimulation

    const batchOfDeposits = await connection.simulateTransaction(transaction);
    const logEvents = parser.parseLogs(batchOfDeposits.value.logs!);
    events.push(...Array.from(logEvents));
  }
  return events;
};

export const getDeposits = async ({
  isUsed = true,
  realmPk,
  walletPk,
  communityMintPk,
  client,
  connection,
}: {
  isUsed?: boolean | undefined;
  realmPk: PublicKey;
  walletPk: PublicKey;
  communityMintPk: PublicKey;
  client: VsrClient;
  connection: Connection;
}) => {
  const clientProgramId = client.program.programId;
  const { registrar } = await getRegistrarPDA(
    realmPk,
    communityMintPk,
    clientProgramId
  );
  const { voter } = await getVoterPDA(registrar, walletPk, clientProgramId);
  const existingVoter = await tryGetVoter(voter, client);
  const existingRegistrar = await tryGetRegistrar(registrar, client);
  const mintCfgs = existingRegistrar?.votingMints || [];
  const mints: Record<string, TokenProgramAccount<MintAccount> | undefined> =
    {};
  let votingPowerFromDeposits = new BN(0);
  let deposits: DepositWithMintAccount[] = [];
  for (const i of mintCfgs) {
    if (i.mint.toBase58() !== emptyPk) {
      const mint = await tryGetMint(connection, i.mint);
      mints[i.mint.toBase58()] = mint;
    }
  }
  if (existingVoter) {
    deposits = existingVoter.deposits
      .map(
        (x, idx) =>
          ({
            ...x,
            mint: mints[mintCfgs![x.votingMintConfigIdx].mint.toBase58()],
            index: idx,
          } as DepositWithMintAccount)
      )
      .filter((x) => typeof isUsed === "undefined" || x.isUsed === isUsed);
    const usedDeposits = deposits.filter((x) => x.isUsed);
    const areThereAnyUsedDeposits = usedDeposits.length;
    if (areThereAnyUsedDeposits) {
      const events = await getDepositsAdditionalInfoEvents(
        client,
        usedDeposits,
        connection,
        registrar,
        voter
      );
      const depositsInfo = events.filter((x) => x.name === DEPOSIT_EVENT_NAME);
      const votingPowerEntry = events.find(
        (x) => x.name === VOTER_INFO_EVENT_NAME
      );
      deposits = deposits.map((x) => {
        const additionalInfoData = depositsInfo.find(
          (info) => info.data.depositEntryIndex === x.index
        ).data;

        x.currentlyLocked = additionalInfoData.locking?.amount || new BN(0);
        x.available = additionalInfoData.unlocked || new BN(0);
        x.vestingRate = additionalInfoData.locking?.vesting?.rate || new BN(0);
        x.nextVestingTimestamp =
          additionalInfoData.locking?.vesting?.nextTimestamp || null;
        x.votingPower = additionalInfoData.votingPower || new BN(0);
        x.votingPowerBaseline =
          additionalInfoData.votingPowerBaseline || new BN(0);
        return x;
      });
      if (
        votingPowerEntry &&
        !votingPowerEntry.data.votingPowerBaseline.isZero()
      ) {
        votingPowerFromDeposits = votingPowerEntry.data.votingPowerBaseline;
      }

      return { deposits, votingPowerFromDeposits };
    }
  }
  return { deposits, votingPowerFromDeposits };
};
